import {useRouteMatch} from "react-router";
import {appPath} from "@web2/gh_routes";

import {UrlTagSlug} from "../../url_utils/tags";

export const useTagFromPathname = () => {
    return useRouteMatch<{tag: UrlTagSlug}>(appPath.searchResult.universalTag)?.params?.tag || undefined;
};
